import { useEffect, useMemo, useState } from "react";
import DateInput from "../DateInput";

const PRESETS = [
  { value: 7, label: "7 j" },
  { value: 30, label: "30 j" },
  { value: 90, label: "90 j" },
];

const computeRange = (preset, customFrom, customTo) => {
  if (preset === "custom" && customFrom && customTo) {
    return { from: new Date(`${customFrom}T00:00:00`).toISOString(), to: new Date(`${customTo}T23:59:59`).toISOString() };
  }
  const days = preset === "custom" ? 30 : preset;
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - days);
  return { from: start.toISOString(), to: end.toISOString() };
};

const PeriodFilter = ({ onChange }) => {
  const [preset, setPreset] = useState(30);
  const [customFrom, setCustomFrom] = useState("");
  const [customTo, setCustomTo] = useState("");

  const range = useMemo(() => computeRange(preset, customFrom, customTo), [preset, customFrom, customTo]);

  useEffect(() => {
    onChange(range);
  }, [range, onChange]);

  return (
    <div className="mb-6 flex flex-wrap items-center gap-3">
      <span className="text-xs font-medium text-gray-400">Période</span>
      <div className="inline-flex items-center gap-0.5 rounded-lg bg-gray-100 p-0.5">
        {PRESETS.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => setPreset(option.value)}
            className={`rounded-md px-3 py-1 text-sm font-medium transition-colors ${preset === option.value ? "bg-white text-gray-900 shadow-sm" : "text-gray-500 hover:text-gray-800"}`}
          >
            {option.label}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-2 text-sm text-gray-400">
        <DateInput
          value={customFrom}
          onChange={(value) => {
            setCustomFrom(value || "");
            setPreset("custom");
          }}
          placeholder="jj/mm/aaaa"
          className="w-28 rounded-md border border-gray-300 p-1.5 text-sm text-gray-900 outline-none transition-all focus:border-primary-500 focus:ring-2 focus:ring-primary-500"
        />
        <span>→</span>
        <DateInput
          value={customTo}
          onChange={(value) => {
            setCustomTo(value || "");
            setPreset("custom");
          }}
          placeholder="jj/mm/aaaa"
          className="w-28 rounded-md border border-gray-300 p-1.5 text-sm text-gray-900 outline-none transition-all focus:border-primary-500 focus:ring-2 focus:ring-primary-500"
        />
      </div>
    </div>
  );
};

export default PeriodFilter;
